import type { GTMEventDataMapping } from '../GTM.d'
import {
    cartState,
    cartItemMapping,
    checkoutStepData,
    orderData,
    pdpData,
    plpData,
    searchData,
    productClick
} from './events'
import {
    getCartItemPrice,
    getCategoryPath,
    getConfigurableVariant,
    getMapProductDetails,
    getCategoryName
} from './functions'

const cartItemMappingValue = cartItemMapping(
    getCategoryPath,
    getCartItemPrice,
    getConfigurableVariant
)

const cartStateChange = {
    updatedItems: {
        data_source: ['updatedItems'],
        mapping: cartItemMappingValue,
        strict: true
    },
    ...cartState(cartItemMappingValue)
}

const mapProductDetails = getMapProductDetails(getCategoryName)

export const defaultMapping: GTMEventDataMapping = {
    USER_STATE: false,
    USER_LOGIN: false,
    USER_LOGOUT: false,
    CART_VIEW: cartState(cartItemMappingValue),
    CART_STATE: cartState(cartItemMappingValue),
    REMOVE_FROM_CART: cartStateChange,
    ADD_TO_CART: cartStateChange,
    PAGE_VIEW: false,
    PAGE_VIEW_DATA: false,
    TRIGGER_IMMEDIATELY: false,
    PLP: plpData(mapProductDetails, getCategoryName),
    PDP: pdpData(getCategoryPath, getCategoryName),
    SEARCH: searchData(mapProductDetails),
    PLACE_ORDER: orderData(cartItemMappingValue),
    CHECKOUT: checkoutStepData(cartItemMappingValue),
    PRODUCT_CLICK: productClick(),
    PROMOTION_CLICK: pdpData(getCategoryPath, getCategoryName),
    PROMOTION_VIEW: false,
    CHECKOUT_OPTION: false
}
